import CampaignIcon from "@mui/icons-material/Campaign";
import styles from "./AnimateText.css";

function AnimatedText() {
  return (
    <div className="relative overflow-hidden flex flex-row items-center gap-2 bg-gradient-to-r from-brand-gold-600 via-brand-gold-400 to-brand-gold-600 border-b-2 border-brand-gold-200/70 w-full h-11 px-3 rounded-t-lg shadow-gold">
      <span
        aria-hidden="true"
        className="pointer-events-none absolute top-[-40%] bottom-[-40%] left-[-28%] w-[22%] bg-gradient-to-r from-transparent via-white/60 to-transparent -skew-x-[18deg] animate-header-sheen"
      />
      <CampaignIcon
        className="text-brand-ink-onGold flex-shrink-0 animate-pulse"
        fontSize="small"
      />
      <div className="w-full h-auto parent-div">
        <span className="text-sm font-heading font-extrabold text-brand-ink-onGold running-text">
          ยังไม่เปิดด พัฒนาอยู่วว เว็บเเทงหวยอันดับ 1 ที่นี่ MEESOK.com
        </span>
      </div>
    </div>
  );
}

export default AnimatedText;
